//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapState, mapActions } from "vuex";
const menuList = [
  {
    icon: "dashboard",
    label: "Dashboard",
    route: "dashboard",
  },
  {
    icon: "add_box",
    label: "DIP",
    route: "dip",
  },
  {
    icon: "library_books",
    label: "Permohonan",
    route: "permohonan",
  },
  {
    icon: "error",
    label: "Keberatan",
    route: "keberatan",
  },
  {
    icon: "note",
    label: "Nota Dinas (Masuk)",
    route: "nodin",
  },
  {
    icon: "chat",
    label: "Nota Dinas (Keluar)",
    route: "jawabannodin",
  },
];
const pengaturan = [
  {
    icon: "subdirectory_arrow_right",
    label: "Kategori Informasi",
    route: "kategori_informasi",
  },
  {
    icon: "subdirectory_arrow_right",
    label: "Bentuk Informasi",
    route: "bentuk_informasi",
  },
  {
    icon: "subdirectory_arrow_right",
    label: "Alasan Penolakan",
    route: "alasan_penolakan",
  },
  {
    icon: "subdirectory_arrow_right",
    label: "Unit Kerja",
    route: "unit_kerja",
  },
  {
    icon: "subdirectory_arrow_right",
    label: "Jabatan",
    route: "jabatan",
  },
  {
    icon: "subdirectory_arrow_right",
    label: "User Admin",
    route: "user_admin",
  },
  {
    icon: "subdirectory_arrow_right",
    label: "Peran Pengguna",
    route: "peran_pengguna",
  },
  {
    icon: "subdirectory_arrow_right",
    label: "User Pemohon",
    route: "user_pemohon",
  },
];

const halaman = [
  {
    icon: "today",
    label: "Agenda",
    route: "agenda",
  },
  {
    icon: "article",
    label: "Berita",
    route: "news",
  },
  {
    icon: "library_books",
    label: "Laporan",
    route: "laporan",
  },
  {
    icon: "people",
    label: "Pejabat",
    route: "pejabat",
  },
  {
    icon: "assignment_late",
    label: "Regulasi",
    route: "regulasi",
  },
  {
    icon: "assignment",
    label: "SOP",
    route: "sop",
  },
  {
    icon: "aspect_ratio",
    label: "Banner",
    route: "banner",
  },
];

export default {
  name: "User",
  components: {
    // UserLogin
  },
  data: function() {
    return {
      loggedIn: true,
      request: {},
      drawer: false,
      menuList,
      pengaturan, halaman,
      selected: "Dashboard",
    };
  },
  computed: mapState(["currentAdmin"]),
  async mounted() {
    if (!localStorage.getItem("token-admin")) {
      this.$router.push("/admin-login");
    }
    await this.getCurrentAdmin();
    if(this.currentAdmin == null) {
      localStorage.removeItem("token-admin")
      this.$router.push("/admin-login");
    }
  },
  methods: {
    ...mapActions(["getCurrentAdmin"]),
    logout() {
      localStorage.removeItem("token-admin");
      this.getCurrentAdmin();
      this.$router.push("/admin-login");
    },
    onSelect(data) {
      this.selected = data;
      this.$router
        .push({ name: data.route})
        // .push({ name: data.route, params: { ctgr_id: data.route } })
        .catch(() => {});
    },
  },
};
